import React, { useMemo, useState, useEffect } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Add, Delete } from '@mui/icons-material';

const InfoTab = ({ data, additionalExpenses: initialExpenses = [], onDataChange }) => {
  const classes = useStyles();
  const [additionalExpenses, setAdditionalExpenses] = useState([]);
  const [newExpense, setNewExpense] = useState({ note: '', suma: '' });

  useEffect(() => {
    if (initialExpenses && initialExpenses.length > 0) {
      setAdditionalExpenses(initialExpenses);
    }
  }, [initialExpenses]);

  const info = useMemo(() => {
    if (!data || data.length === 0) return { note: '', suma: 0, priceCalc: 0 };
    return data.reduce((acc, els) => ({
      note: acc?.note || '',
      suma: acc.suma + (els.clientTotals?.suma || 0),
      priceCalc: acc.priceCalc + (els.clientTotals?.priceCalc || 0),
    }), { note: '', suma: 0, priceCalc: 0 });
  }, [data]);

  const additionalTotal = useMemo(() => {
    return additionalExpenses.reduce((sum, exp) => sum + (parseFloat(exp.suma) || 0), 0);
  }, [additionalExpenses]);

  const finalTotal = useMemo(() => {
    return info.priceCalc + additionalTotal;
  }, [info.priceCalc, additionalTotal]);

  const handleRemoveExpense = (id) => {
    const updated = additionalExpenses.filter(exp => exp.id !== id);
    setAdditionalExpenses(updated);
    if (onDataChange) onDataChange(updated);
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('uk-UA', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(value || 0);
  };

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ width: '60px' }}>№</TableCell>
            <TableCell style={{ width: '500px' }}>Нотатка</TableCell>
            <TableCell style={{ width: '150px' }}>Сума до розрахунку</TableCell>
            <TableCell style={{ width: '80px' }}>Дії</TableCell>
          </TableRow>
          <TableRow className={classes.grandTotalRow}>
            <TableCell colSpan={2}><strong>ЗАГАЛЬНА СУМА ДО РОЗРАХУНКУ</strong></TableCell>
            <TableCell align="right"><strong>{formatNumber(finalTotal)}</strong></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.summaryRow}>
            <TableCell colSpan={2}><strong>Загальна сума по клієнтам</strong></TableCell>
            <TableCell align="right"><strong>{formatNumber(info.priceCalc)}</strong></TableCell>
            <TableCell></TableCell>
          </TableRow>

          {additionalExpenses.map((expense, index) => (
            <TableRow key={expense.id} className={classes.dataRow}>
              <TableCell align="center">{index + 1}</TableCell>
              <TableCell>{expense.note}</TableCell>
              <TableCell align="right">{formatNumber(expense.suma)}</TableCell>
              <TableCell align="center">
                <IconButton size="small" onClick={() => handleRemoveExpense(expense.id)} color="error">
                  <Delete fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}

          <TableRow className={classes.inputRow}>
            <TableCell align="center">
            </TableCell>
            <TableCell>
              {newExpense?.note || ''}
            </TableCell>
            <TableCell>
              {newExpense?.suma || 0}
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InfoTab;

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    border: '1px solid #000',
    height: 'calc(100vh - 310px)',
        minHeight: '250px',

    overflow: 'auto',
    '& .MuiPaper-root': { boxShadow: 'none' }
  },
  table: {
    borderCollapse: 'collapse',
    '& .MuiTableCell-root': {
      fontSize: '11px',
      fontFamily: 'Arial, sans-serif',
      padding: '4px 8px',
      border: '1px solid #000',
      lineHeight: '1.2',
      verticalAlign: 'middle'
    },
    '& .MuiTableCell-head': {
      backgroundColor: '#DDDDDD',
      fontWeight: 'bold',
      textAlign: 'center',
      fontSize: '11px',
      padding: '6px 4px',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }
  },
  grandTotalRow: {
    position: 'sticky',
    top: '30px',
    zIndex: 50,
    '& .MuiTableCell-root': {
      backgroundColor: '#DDDDDD',
      fontWeight: 'bold',
      border: '1px solid #000',
      fontSize: '11px'
    }
  },
  summaryRow: {
    '& .MuiTableCell-root': {
      backgroundColor: '#E8F4F8',
      fontWeight: 'bold',
      fontSize: '12px'
    }
  },
  dataRow: {
    '& .MuiTableCell-root': { backgroundColor: '#ffffff' },
    '&:nth-child(even)': { '& .MuiTableCell-root': { backgroundColor: '#f9f9f9' } }
  },
  inputRow: {
    '& .MuiTableCell-root': { backgroundColor: '#F0F8FF', padding: '8px' },
    '& .MuiTextField-root': { '& .MuiInputBase-root': { fontSize: '11px', fontFamily: 'Arial, sans-serif' } }
  }
}));
